//Backend URL (already includes /api/v1, so endpoints below start with "/")

export const DOMAIN_URL = "https://api-supplier.virtualtoactual.cloud/";
//export const DOMAIN_URL = "https://api-supplier-test.v2a.digital/";

//Staging
export const API_BASE_URL = `${DOMAIN_URL}api/v1`;

//Live
//export const API_BASE_URL = `${DOMAIN_URL}api/v1`;

// Raw error log files are served from the backend host root, e.g. https://api-supplier.virtualtoactual.cloud/error-logs/<log_file>
export const ERROR_LOG_FILE_BASE_URL = `${API_BASE_URL.replace(/\/api\/v1\/?$/, "")}/error-logs`;

const withQuery = (path: string, qs?: string) => (qs ? `${path}?${qs}` : path);

// list / details / create / update / delete for a REST resource at `base`
const crud = (base: string) => ({
  list: (qs?: string) => withQuery(base, qs),
  details: (id: number | string) => `${base}/${id}`,
  create: base,
  update: (id: number | string) => `${base}/${id}`,
  delete: (id: number | string) => `${base}/${id}`,
});

export const SUPPLIER_BACKEND_API_ENDPOINTS = {
  authentication: {
    login: "/users/login",
    verifyToken: "/users/verify-token",
    menuAccess: (roleCode: number | string) =>
      withQuery("/users/menu-access", `role_code=${roleCode}`),
    changePasswordLink: "/users/change-password-link",
  },

  suppliers: {
    ...crud("/suppliers"),
    supplierByCode: (supplierCode: string) => `/suppliers/code/${supplierCode}`,
    // NOTE: assumed route — confirm against the backend
    // verifyDocument: (documentId: number | string) =>
    //   `/suppliers/documents/${documentId}/verify`,
    checkAvailability: (queryString: string) =>
      `/suppliers/check-availability?${queryString}`,
  },
  adminSupplierDocument: {
    verifyDocument: (documentId: number | string) =>
      `/admin/supplier-documents/${documentId}`,
  },

  agents: {
    ...crud("/agents"),
    agentByCode: (agentCode: string) => `/agents/code/${agentCode}`,
    checkAvailability: (queryString: string) =>
      `/agents/check-availability?${queryString}`,
  },
  vendors: crud("/vendors"),
  flights: crud("/flights"),

  inventory: {
    ...crud("/inventory"),
    fareSearch: "/inventory/fare-search", //POST
    fareCheck: "/inventory/fare-check", //POST
    dateAvailablity: "/inventory/availablity", //POST
    updateExitingFare: "/inventory/update-fare", //POST
    addNewSeat: "/inventory/update-seat", //POST
    decreaseExitingSeat: "/inventory/update-seat", //POST
    updateInventoryDetail: "/inventory/update-inventory", //POST
  },

  inventoryBulkUpload: {
    ...crud("/inventory/bulkupload"),
    downloadTemplate: (format: "csv") =>
      `/inventory/bulkupload/template?format=${format}`,
    listUploadHistory: (qs?: string) =>
      withQuery("/inventory/bulkupload/files", qs),
    details: (fileid: number | string) =>
      `/inventory/bulkupload/files/${fileid}`,
  },
  adminTransactions:{
      transactions: (qs?: string) =>
      withQuery("/wallet/admin/transactions", qs)
  },
  supplierWallet: {
    transactions: (qs?: string) =>
      withQuery("/wallet/supplier/transactions", qs),
    balance: (supplier_code: number | string) =>
      `/wallet/supplier/balance?supplier_code=${supplier_code}`,
  },

  common: {
    uploadFile: "/common/upload",
  },

  reports: {
    dashboard: "/reports/dashboard",
  },

  airlines: crud("/airlines"),
  airports: crud("/airports"),

  countries: crud("/location/countries"),
  states: crud("/location/states"),
  cities: crud("/location/cities"),

  pincode: {
    ...crud("/location/pincode"),
    detail: (pin: number | string) =>
      withQuery("/location/pincode", `pin=${pin}`),
  },

  rbacRoles: crud("/rbac/roles"),
  rbacModules: crud("/rbac/modules"),
  rbacMenus: crud("/rbac/menus"),
  rbacRoleModulesAccess: crud("/rbac/role-module-access"),
  walletTopup: {
    ...crud("/wallet/requests"),
    details: (request_ref: number | string) =>
      `${"/wallet/requests"}/${request_ref}`, //GET
    approve: (request_ref: number | string) =>
      `${"/wallet/requests"}/${request_ref}/approve`, //PUT
    reject: (request_ref: number | string) =>
      `${"/wallet/requests"}/${request_ref}/reject`, //PUT
  },
  logs: {
    errors: (qs?: string) => withQuery("/logs/errors", qs),
    errorDetails: (id: number | string) => `/logs/errors/${id}`,
    serviceApi: (qs?: string) => withQuery("/logs/service-api", qs),
    serviceApiDetails: (id: number | string) => `/logs/service-api/${id}`,
  },
  notifications: {
    ...crud("/notifications"),
    unreadCount: "/notifications/unread-count",
    markAllRead: "/notifications/mark-all-read",
    singleMarkRead: (notificationId: number | string) =>
      `${"/notifications"}/${notificationId}/read`,
  },
  supplierInventoryBlackout: crud("/admin/supplier-blackouts"),
  supplierInventoryPriority: crud("/admin/supplier-priorities"),
  markups: crud("/admin/flight-markups"),
  bankDetails: {
    ...crud("/bank-details"),
    setPrimary: (bankid: number) => `/bank-details/${bankid}/set-primary`,
    verify: (bankid: number) => `/bank-details/${bankid}/verify`,
  },
  bookings: {
    ...crud("/bookings"),
    bookingByCode: (booking_code: string) => `/bookings/code/${booking_code}`, //GET
    confirmBooking: (id: string) => `/bookings/${id}/confirm`, //PUT
    bookingHIstory: (id: string) => `/bookings/${id}/history`, //GET
    // updatePassenger: (bookingId: number | string, passengerId: number | string) =>
    //   `/bookings/${bookingId}/passengers/${passengerId}`, //PUT
    updatePassenger: (bookingId: number | string, passengerId: number | string) =>
      `/bookings/${bookingId}/ticket-number`, //PATCH
    updatePnr: (bookingId: number | string) => `/bookings/${bookingId}/pnr`, //PATCH
  },
  enquiries: crud("/enquiries"),
  promotions: {    
    list: (qs?: string) => withQuery("/inventory/sector-fares", qs),
  },
  offers: {
    ...crud("/offers"),
    getOfferByCode: (code: string) =>`/offers/code/${code}`, //GET
  },
  staff: {
    ...crud("/users"),
    staffList: (qs?: string) => withQuery("/users/staff-users", qs),//GET
    getSingleStaff: (id: number | string, role_code: number | string) => `/users/${id}?role_code=${role_code}`,//GET
    staffByCode: (staffCode: string) => `/users/code/${staffCode}`,//GET
    updateStatus: `/users/status`,//POST
    changePassword: `/users/admin-change-password`,//POST
  },
};
